import React, { useState } from "react";
import ModalUserColumns from "../modal_user_columns/ModalUserColumns";
import HtmlText from "../../shared/html-text/HtmlText";

const LinkModalUserColumn = ({ column, htmlContent, tenantId, templates, currentUser }) => {
  const [showModalInfo, setShowModalInfo] = useState(false);
  return (
    <React.Fragment>
      <span
        onClick={() => setShowModalInfo(true)}
      ><HtmlText htmlText={htmlContent}/></span>
      <ModalUserColumns
        isModalVisible={showModalInfo}
        templates={templates}
        columnId={column.id}
        onCancelModal={() => setShowModalInfo(false)}
        tenantId={tenantId}
        modalTitle={column.name}
        column={column}
        currentUser={currentUser}
      />
    </React.Fragment>
  );
};

export default LinkModalUserColumn;
